import { useSyncExternalStore } from 'react';

import {
  getPreviewFullHeadMprSlicesStatus,
  subscribePreviewFullHeadMprSlices,
} from '../lib';

export const usePreviewFullHeadMprSlicesStatus = () =>
  useSyncExternalStore(
    subscribePreviewFullHeadMprSlices,
    getPreviewFullHeadMprSlicesStatus,
  );
